import { render } from "./DownloadApp.vue?vue&type=template&id=46a9faac&scoped=true&ts=true"
import script from "./DownloadApp.vue?vue&type=script&lang=ts"
export * from "./DownloadApp.vue?vue&type=script&lang=ts"

import "./DownloadApp.vue?vue&type=style&index=0&id=46a9faac&scoped=true&lang=css"

import exportComponent from "/builds/otto-tech/otto-financas-site/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46a9faac"]])

export default __exports__